import React from 'react'

import Separator from '../../../../../components/pdf/Separator'
import View from '../../../../../components/pdf/View'
import { Bullets, Paragraph, SectionHeading } from './_shared/Prose'

/**
 * Seção 14 (do modelo real) - Gestão Participativa: CIPA e Capacitação. Texto literal
 * do modelo aprovado por Julia Buzzo ("Modelo PGR 2026 - Banco Bradesco_Varejo").
 * Substitui o placeholder institucional anterior (arquivo era
 * `15.TreinamentoSection.js` — o título real desta seção do documento é "Gestão
 * Participativa: CIPA e Capacitação", que já abrange o tema treinamento).
 */
const GestaoParticipativaCipaSection = () => (
  <View id="14">
    <Separator weight={15} />
    <SectionHeading numero={14}>GESTÃO PARTICIPATIVA: CIPA E CAPACITAÇÃO</SectionHeading>

    <Paragraph>
      A organização assegura a constituição da CIPA – Comissão Interna de Prevenção de Acidentes e de Assédio,
      conforme critérios da NR-5, em todas as unidades aplicáveis. A Comissão atua de forma ativa na prevenção de
      acidentes, participando da análise de riscos e da proposição de melhorias.
    </Paragraph>

    <Paragraph>Além disso, treinamentos periódicos são oferecidos a todos os trabalhadores, com temas como:</Paragraph>
    <Bullets
      items={[
        'Ergonomia aplicada ao trabalho presencial e remoto;',
        'Prevenção de acidentes em ambientes administrativos;',
        'Reconhecimento e controle de riscos;',
        'Formação específica para membros da CIPA (Comissão Interna de Prevenção de Acidentes e de Assédio) e designados.'
      ]}
    />

    <Paragraph>
      As capacitações são disponibilizadas em ambiente virtual, garantindo acesso prático e flexível para todos os
      funcionários.
    </Paragraph>

    <Separator weight={15} />
  </View>
)

export default GestaoParticipativaCipaSection
